exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hamburger-inner[data-v-585b574b], .hamburger-inner[data-v-585b574b]::before, .hamburger-inner[data-v-585b574b]::after {\n    background-color: var(--variant);\n}\n", ""]);

// exports
